import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Component, Inject, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


import { HttpClient } from '@angular/common/http';

import { ActivatedRoute, Params } from '@angular/router';
import { UMPCategory, Utils } from '../../../../../utils/utils';
import { SpinnerOverlayService } from '../../../../../services/spinner-overlay.service';
import { SaveService } from '../../../../../services/save.service';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { CreateDaworkspaceComponent } from '../../../group/daworkspace/createdaworkspace/createdaworkspace.component';
import { MatDialog } from '@angular/material/dialog';


interface DANode {
    groupId: string;
    groupName: string;
    subGroupsAllowed: boolean,
    selected?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    parent?: DANode;
    groups: DANode[];
}




@Component({
    selector: "daworkspace",
    templateUrl: './daworkspace.component.html',
    styleUrls: ['./daworkspace.component.less', '../../../../../style/new-generic-styles.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class DAWorkspace implements OnDestroy {
    @Input() public groupmgmtcallback: Function | undefined;
    userId = '';
    public TREE_DATA: DANode[] = [];/*** */

    public selectedNodes: string[] = [];
    public unSelectedNodes: string[] = [];
    public disabledNodes: string[] = [];

    public treeControl: NestedTreeControl<DANode>;
    public dataSource = new MatTreeNestedDataSource<DANode>();
    public rootNodes: any;
    public isExpanded = false;

    public searchString = '';
    public showOnlySelected = false;
    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    showData: boolean = false;
    isCallSucceed: number = 0;

    // Retry policy configuration for Azure propagation delay
    private readonly RETRY_CONFIG = {
        initialDelay: 2000,        // Initial delay of 2 seconds
        maxRetries: 3,             // Maximum 3 retries
        retryDelay: 2000,          // 2 seconds between retries
        backoffMultiplier: 1.5     // Exponential multiplier (2s, 3s, 4.5s)
    };
    private isReloading = false;

    data: TreeManagement<UMPCategory> = {
        SelectedBranches: [],
        UnselectedBranches: [],
        UmpCategory: UMPCategory.DAnalyticsPowerBI
    }
    subscription: any;

    constructor(
        private toastrService: ToastrService,
        private route: ActivatedRoute,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private spinnerOverlayService: SpinnerOverlayService,
        private saveService: SaveService,
        public defaults: DefaultValuesService,
        private dialogForm: MatDialog

    ) {
        this.route.params.subscribe(
            (params: Params) => {
                this.hideData();
            });
        this.treeControl = new NestedTreeControl<DANode>((node) => node.groups)

    }

    onClickLoad() {
        this.subscription = this.defaults.dataAnalyticsTreeSourceChanges$.subscribe(async () => {
            this.resetAll();
        });
    }
    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
    resetAll() {
        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        this.treeControl = new NestedTreeControl<DANode>((node) => node.groups)
        this.dataSource = new MatTreeNestedDataSource<DANode>();
        this.showData = true;
        this.funcGetUserDataAnlytics();
    }
    private preselect() {
        this.unSelectedNodes = [] as string[];
        for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
            if (this.selectedNodes.find(e => e === this.treeControl.dataNodes[i].groupId)) {
                this.itemToggle(true, this.treeControl.dataNodes[i]);
            }
            else
                this.unSelectedNodes.push(this.treeControl.dataNodes[i].groupId);
            if (this.treeControl.dataNodes[i].groups) {

                const alldecendents = this.treeControl.getDescendants(this.treeControl.dataNodes[i]);

                for (let j = 0; j < alldecendents.length; j++) {
                    if (this.selectedNodes.find(e => e === alldecendents[j].groupId)) {
                        this.itemToggle(true, alldecendents[j]);
                    }
                    else
                        this.unSelectedNodes.push(alldecendents[j].groupId);
                }
            }
        }

    }
    public hasChild = (_: number, node: DANode) =>
        !!node.groups && node.groups.length > 0;

    private setParent(node: DANode, parent: DANode | undefined) {
        node.parent = parent;
        if (node.groups) {
            node.groups.forEach((childNode) => {
                this.setParent(childNode, node);
            });
        }
    }

    private checkAllParents(node: DANode) {
        if (node.parent) {
            const descendants = this.treeControl.getDescendants(node.parent);
            node.parent.indeterminate = descendants.some((child) => child.selected);
            this.checkAllParents(node.parent);
        }
    }

    public itemToggle(checked: boolean, node: DANode, manualUpdate: boolean = false) {
        this.saveService.addListener(this)
        this.saveService.showSaveButton();
        node.selected = checked;
        if (node.groups && checked && manualUpdate) {
            node.indeterminate = false;
            this.itemUnselect(node);
        }
        if (node.groups) {
            this.itemDisable(checked, node);
        }
        if (manualUpdate) {
            if (checked) {
                this.data.UnselectedBranches = this.data.UnselectedBranches.filter(x => x !== node.groupId)
                if (this.unSelectedNodes.find(e => e === node.groupId))
                    this.data.SelectedBranches.push(node.groupId);
            }
            else {
                this.data.SelectedBranches = this.data.SelectedBranches.filter(x => x !== node.groupId)
                if (this.selectedNodes.find(e => e === node.groupId))
                    this.data.UnselectedBranches.push(node.groupId);
            }
        }
        this.checkAllParents(node);
    }
    private itemUnselect(node: DANode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => { node.selected ? this.data.UnselectedBranches.push(node.groupId) : null; node.indeterminate = false; node.selected = false });
    }

    private itemDisable(checked: boolean, node: DANode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => {
            node.disabled = checked;
        });
    }

    public onSave() {
        if (this.data.SelectedBranches.length > 0 || this.data.UnselectedBranches.length > 0) {
            this.spinnerOverlayService.setFalseskipInterceptor()
            Utils.httpPostTreeGroupsByType(
                this.http
                , this.baseUrl
                , this.data
                , this.userId
                , this
                , function (tthis: DAWorkspace, data: any) {
                    tthis.data.SelectedBranches = []
                    tthis.data.UnselectedBranches = []
                    tthis.spinnerOverlayService.setTrueskipInterceptor()
                    tthis.funcNotify();
                    tthis.reloadWithRetry();
                    if (tthis.groupmgmtcallback)
                        tthis.groupmgmtcallback(data);
                }
            )
        }
    }

    public hideLeafNode(node: DANode): boolean {
        return new RegExp(this.searchString, 'i').test(node.groupName) === false;
    }


    public hideParentNode(node: DANode): boolean {
        if (
            !this.searchString ||
            node.groupName.toLowerCase().indexOf(this.searchString.toLowerCase()) !==
            -1
        ) {
            return false
        }
        const descendants = this.treeControl.getDescendants(node)

        if (
            descendants.some(
                (descendantNode) =>
                    descendantNode.groupName
                        .toLowerCase()
                        .indexOf(this.searchString.toLowerCase()) !== -1
            )
        ) {
            return false
        }

        return true
    }
    funcGetUserDataAnlytics(forceReload: boolean = false) {
        this.isExpanded = false;
        this.treeControl.dataNodes = [];
        this.TREE_DATA.splice(0, this.TREE_DATA.length);
        // Only set loading state if not in retry mode
        if (this.Tree_Response_State !== -3) {
            this.Tree_Response_State = -2;
        }
        Utils.httpGetUserDataAnlytics(
            this.http
            , this.baseUrl
            , this.userId
            , forceReload
            , this
            , (tthis: DAWorkspace, data: any) => {
                tthis.TREE_DATA = data.treeView; ///******** */
                tthis.disabledNodes = data.disabledPersonae;
                this.lockNodes(this.TREE_DATA);
                //tthis.rootNode = data.treeView[0].groupName;
                tthis.selectedNodes = data.excludedPersonae;
                tthis.rootNodes = structuredClone(data.treeView);
                tthis.smallerTree(tthis.rootNodes);
            });
    }

    async funcGetUserDataAnlyticsAsync(forceReload: boolean = false): Promise<any> {
        this.isExpanded = false;
        this.treeControl.dataNodes = [];
        this.TREE_DATA.splice(0, this.TREE_DATA.length);
        
        if (this.Tree_Response_State !== -3) {
            this.Tree_Response_State = -2;
        }
        
        try {
            const data = await Utils.httpGetUserDataAnlyticsAsync(
                this.http,
                this.baseUrl,
                this.userId,
                forceReload
            );
            
            this.TREE_DATA = data.treeView;
            this.disabledNodes = data.disabledPersonae;
            this.lockNodes(this.TREE_DATA);
            this.selectedNodes = data.excludedPersonae;
            this.rootNodes = structuredClone(data.treeView);
            this.smallerTree(this.rootNodes);
            
            return data;
        } catch (error) {
            this.Tree_Response_State = -1;
            console.error('Error loading data analytics:', error);
            throw error;
        }
    }

    smallerTree(smallTREE_DATA) {
        smallTREE_DATA.forEach((parent) => {
            parent.groups?.forEach((child) => {
                delete child.groups;
            });
        });
        //smallTREE_DATA=smallTREE_DATA.flatMap((node) => node.children);
        this.treeControl.dataNodes = smallTREE_DATA;
        this.dataSource.data = smallTREE_DATA;
        Object.keys(this.dataSource.data).forEach((key) => {
            this.setParent(this.dataSource.data[key], undefined);

        });
        this.preselect();
        // Set success state after tree is ready (only if not in retry mode)
        if (!this.isReloading) {
            this.Tree_Response_State = 1;
        }

    }
    longTreeExpandAll() {
        this.treeControl.dataNodes = this.TREE_DATA;
        this.dataSource.data = this.TREE_DATA;
        Object.keys(this.dataSource.data).forEach((key) => {
            this.setParent(this.dataSource.data[key], undefined);

        }
        )
        this.preselect();
        this.isExpanded = true;
        this.treeControl.expandAll()
    }

    expandTriggered(name) {
        this.treeControl.dataNodes = this.TREE_DATA;
        this.dataSource.data = this.TREE_DATA;
        Object.keys(this.dataSource.data).forEach((key) => {
            this.setParent(this.dataSource.data[key], undefined);

        }
        )
        this.preselect();
        this.expandNodeByName(name);
        this.isExpanded = true;

    }
    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('DataAnalytics & PowerBI request sent successfully !', 'Data Analytics and PowerBI Workspaces!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('DataAnalytics & PowerBI request not sent successfully !', 'Data Analytics and PowerBI Workspaces!');
        }
    }
    expandNodeByName(name: string) {
        const node = this.findNodeByName(this.treeControl.dataNodes, name);
        if (node) {
            this.treeControl.expand(node);
        }
    }

    findNodeByName(nodes: DANode[], name: string): DANode | undefined {
        for (const node of nodes) {
            if (node.groupName === name) {
                return node;
            }
            //if (node.groups) {
            //    const foundNode = this.findNodeByName(node.groups, name);
            //    if (foundNode) {
            //        return foundNode;
            //    }
            //}
        }
        return undefined;
    }

    openPowerbiWorkspacePopup() {
        const dialog = this.dialogForm.open(CreateDaworkspaceComponent, {
            panelClass: ["custom-mat-dialog_v2"],
            disableClose: true,
            width: '550px',
            data: {}
        })
    }

    hideData() {
        this.showData = false;
        this.TREE_DATA = [];
        this.selectedNodes = [];
        this.unSelectedNodes = [];
        this.disabledNodes = [];
        this.rootNodes = [];
    }

    private lockNodes(datanodes: DANode[]) {
        datanodes.forEach((node) => {
            if (this.isNodeDisabled(node.groupId)) {
                node.disabled = true;
            }
            else {
                const descendants = this.treeControl.getDescendants(node);
                descendants.forEach(node => {
                    if (this.isNodeDisabled(node.groupId)) {
                        node.disabled = true;
                    }
                });
            }
        });
    }

    private isNodeDisabled(groupId: string) {
        return this.disabledNodes.includes(groupId)
    }

    private async reloadWithRetry(
        initialDelay: number = this.RETRY_CONFIG.initialDelay,
        maxRetries: number = this.RETRY_CONFIG.maxRetries,
        baseRetryDelay: number = this.RETRY_CONFIG.retryDelay
    ): Promise<void> {
        if (this.isReloading) {
            console.log('Reload already in progress, skipping...');
            return;
        }

        this.isReloading = true;
        this.Tree_Response_State = -3;
        console.log('Waiting for Azure propagation with intelligent retry');

        console.log(`Initial delay: ${initialDelay}ms`);
        await this.delay(initialDelay);

        for (let attempt = 0; attempt <= maxRetries; attempt++) {
            if (attempt > 0) {
                const retryDelay = baseRetryDelay * Math.pow(this.RETRY_CONFIG.backoffMultiplier, attempt - 1);
                console.log(`Retry ${attempt}/${maxRetries} - waiting ${retryDelay}ms`);
                await this.delay(retryDelay);
            }

            console.log(`Attempt ${attempt + 1}/${maxRetries + 1} - fetching from Azure`);
            
            const isLastAttempt = (attempt === maxRetries);
            
            if (isLastAttempt) {
                this.isReloading = false;
            }
            
            try {
                await this.funcGetUserDataAnlyticsAsync(true);
                
                if (this.Tree_Response_State === 1) {
                    console.log(`Changes detected on attempt ${attempt + 1}!`);
                    this.isReloading = false;
                    return;
                }
                
                console.log(`Attempt ${attempt + 1} - no changes yet`);
                
                if (!isLastAttempt) {
                    this.Tree_Response_State = -3;
                    this.isReloading = true;
                }
                
            } catch (error) {
                console.error(`Attempt ${attempt + 1} failed:`, error);
                
                if (isLastAttempt) {
                    this.isReloading = false;
                    return;
                }
                
                this.Tree_Response_State = -3;
                this.isReloading = true;
            }
        }

        console.log('Retry completed');
        this.isReloading = false;
    }

        private delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
